import React from 'react';
import { motion } from 'framer-motion';
import { portfolioData } from '../data/mock';

const KTMSection = () => {
  const { hobbies } = portfolioData;
  const { ktm } = hobbies;
  
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24 relative">
      <div className="max-w-5xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>{ktm.heading}</h2>
        </motion.div>
        
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="text-center mb-8 sm:mb-10 md:mb-12" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}>
          {ktm.subtitle}
        </motion.p>
        
        <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="relative flex justify-center mb-8 sm:mb-12">
          <svg className="absolute inset-0 w-full h-full opacity-15" viewBox="0 0 400 200" preserveAspectRatio="xMidYMax slice">
            <polygon points="0,200 50,120 100,160 150,80 200,140 250,60 300,130 350,90 400,150 400,200" fill="rgba(20,30,45,0.8)"/>
          </svg>
          
          <svg width="280" height="150" viewBox="0 0 350 180" fill="none" className="relative z-10 sm:w-[350px] sm:h-[180px]">
            <ellipse cx="75" cy="140" rx="40" ry="40" stroke="rgba(180,195,220,0.2)" strokeWidth="2" fill="rgba(15,20,28,0.6)"/>
            <ellipse cx="275" cy="140" rx="40" ry="40" stroke="rgba(180,195,220,0.2)" strokeWidth="2" fill="rgba(15,20,28,0.6)"/>
            <ellipse cx="75" cy="140" rx="20" ry="20" fill="rgba(10,15,22,0.8)"/>
            <ellipse cx="275" cy="140" rx="20" ry="20" fill="rgba(10,15,22,0.8)"/>
            <path d="M75 140 L120 70 L230 60 L275 140" stroke="rgba(180,195,220,0.2)" strokeWidth="2" fill="none"/>
            <path d="M120 70 L145 35 L165 38 L155 70" stroke="rgba(180,195,220,0.2)" strokeWidth="2" fill="rgba(15,20,28,0.6)"/>
            <path d="M155 70 L230 60 L240 80 L165 85 Z" fill="rgba(15,20,28,0.6)" stroke="rgba(180,195,220,0.2)" strokeWidth="1"/>
            <path d="M180 60 L200 45 L220 48 L210 62" fill="rgba(15,20,28,0.6)" stroke="rgba(180,195,220,0.15)" strokeWidth="1"/>
            <path d="M240 85 L280 95 L275 105 L235 95" fill="rgba(20,30,40,0.8)" stroke="rgba(180,195,220,0.15)" strokeWidth="1"/>
          </svg>
          
          <div className="absolute bottom-10 left-0 right-0 overflow-hidden h-20">
            {[...Array(6)].map((_, i) => (
              <motion.div key={i} className="absolute h-px" style={{ width: `${Math.random() * 40 + 20}px`, top: `${Math.random() * 100}%`, right: '-50px', background: 'rgba(180, 195, 220, 0.2)' }}
                animate={{ x: [-400, 0] }} transition={{ duration: 0.8 + Math.random() * 0.5, repeat: Infinity, delay: i * 0.2, ease: 'linear' }} />
            ))}
          </div>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8 }}
          whileHover={{ scale: 1.01, y: -2 }}
          className="glass-panel p-6 sm:p-8 md:p-10 mb-6 sm:mb-8"
        >
          {ktm.philosophy.split('\n\n').map((para, i) => (
            <p key={i} className="mb-3 sm:mb-4 last:mb-0 text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>{para}</p>
          ))}
        </motion.div>
        
        <motion.p 
          initial={{ opacity: 0 }} 
          whileInView={{ opacity: 1 }} 
          viewport={{ once: true }} 
          transition={{ duration: 0.8, delay: 0.2 }} 
          className="text-center text-base sm:text-lg md:text-xl" 
          style={{ fontFamily: 'Cinzel, serif', fontStyle: 'italic', color: 'rgba(180, 195, 220, 0.8)' }}
        >
          "{ktm.closingQuote}"
        </motion.p>
      </div>
    </section>
  );
};

export default KTMSection;